import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router";
import { Title } from '@angular/platform-browser';
import { NodeService } from '../../../shared/services/nodeservice.service';
import { Applications } from '../../../shared/services/applications';
import { FormGroup, FormBuilder, FormControl } from "@angular/forms";

interface applicationStatus {
    statusName: string;
    value: string;
}

interface applicationOfferStatus {
    offerStatusName: string;
    value: string;
}

@Component({
    selector: 'app-subscription-applications',
    templateUrl: './subscription-applications.component.html'
})
export class SubscriptionApplicationsComponent implements OnInit {

    loading: boolean;
    files1: Applications[];
    selectedNode1: Applications;

    cols: any[];

    filterForm: FormGroup;
    applicationStatus: applicationStatus[];
    selectedStatus: applicationStatus[];
    status: any;
    applicationOfferStatus: applicationOfferStatus[];
    selectedOfferStatus: applicationOfferStatus[];
    offerStatus: any;

    constructor(private title: Title, private router: Router, private nodeService: NodeService, private fb: FormBuilder) {
        this.title.setTitle('Applications | XYZ Corp. Verification Workspace');

        this.status = [
            { statusName: 'Pending Finance', value: '1' },
            { statusName: 'Complete', value: '2' },
            { statusName: 'New Application', value: '3' },
            { statusName: 'Pending Payment', value: '4' },
            { statusName: 'Rejected', value: '5' }
        ];

        this.offerStatus = [
            { offerStatusName: 'Now Open', value: '1' },
            { offerStatusName: 'Pending', value: '2' },
            { offerStatusName: 'Registration Open', value: '3' }
        ];
    }

    ngOnInit() {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0)
        });

        this.loading = true;
        this.nodeService.getApplications().then(files => this.files1 = files);

        this.filterForm = this.fb.group({
            'applicationStatus': new FormControl(null),
            'applicationOfferStatus': new FormControl(null),
            'dateFrom': new FormControl(null),
            'dateTo': new FormControl(null),
            'searchText': new FormControl(null),
        });
    }

    setStatusClass(status) {
        switch (status) {
            case 'Pending Finance':
                return 'purple';
            case 'Complete':
                return 'green';
            case 'New Application':
                return 'grey';
            case 'Pending Payment':
                return 'blue';
            case 'Rejected':
                return 'red';
        }
    }

}
